export const rolePagesAccess = {
  all: [
    'main',
    'unauthorized',
    'thank-you',
    '404',
    '101',
    'unupgraded',
    'new-password',
    'reset-sent',
    'terms-and-conditions',
    'privacy-policy',
    'packages',
    'login-credentials',
    'master-credentials',
  ],
  guest: [
    'reset-password',
    'verify-code',
    'login',
    'signup',
    'login-password',
    'login-email-notification',
    'login-code-verification',
    'new-client',
    'login-credentials',
    'master-credentials',
  ],
  auth: [
    'settings',
    'statements',
    'data-room-with-insider-statement',
    'data-room-no-insider-statement',
    'insider-list-statement',
    'decryption-request-sent',
    'privacy-policy-statement',
    'data-room-classic-statement',
    'statement-compliance-sign',
  ],
  admin: [
    'serviceprovider',
    'site-documents',
    'site-document-edit',
    'site-document-create',
    'my-logins',
    'admin-billing',
    'admin-client-billing',
    'signup',
    'adminEmailFolder',
    'editEmailTemplate',
    'editStatement',
    'change-password',
    'era-settings',
    'settings',
  ],
  client_contact: [
    'new-contact',
    'add-contact-pdmr',
    'edit-contact',
    'delay-insider-information',
    'delay-insider-information-mar5',
    'new-info-qualifications',
    'specific-insider-details',
    'classification-info',
    'specific-insiders',
    'insider-list',
    'control-panel-insider-list',
    'data-room-details',
    'data-room-folder',
    'data-rooms',
    'period-ban',
    'confidential-details',
    'new-confidential',
    'confidential-list',
    'published-reports',
    'pdmr-list',
    'dashboard',
    'info-requalification',
    'settings',
    'upload-application',
    'my-logins',
    'data-room-details',
    'control-panel-data-room',
    'market-data-room-details',
    'non-market-data-room-details',
    'data-rooms',
    'terms',
    'billing-data',
    'subscriptions',
    'sync-data',
    'era',
    'client-emails-folder',
    'client-edit-email-template',
    'client-edit-privacy-policy',
    'client-compare-privacy-policy',
    'add-new-transaction',
    'users',
    'advisory-companies',
    'advisory-insider-lists',
    'advisory-insider-details',
  ],
  delegated_user: {
    all: ['dashboard'],
    read_qualify_delay_inside_info: ['classification-info'],
    edit_qualify_delay_inside_info: [
      'delay-insider-information',
      'delay-insider-information-mar5',
      'classification-info',
      'new-info-qualifications',
      'info-requalification',
    ],
    read_insider_list: [
      'specific-insiders',
      'insider-list',
      'control-panel-insider-list',
      'confidential-list',
      'specific-insider-details',
      'confidential-details',
    ],
    edit_insider_list: [
      'specific-insiders',
      'insider-list',
      'control-panel-insider-list',
      'confidential-list',
      'specific-insider-details',
      'confidential-details',
    ],
    read_advisory_list: ['advisory-companies', 'advisory-insider-lists', 'advisory-insider-details'],
    edit_advisory_list: ['advisory-companies', 'advisory-insider-lists', 'advisory-insider-details'],
    read_pdmr_pca_transaction: ['pdmr-list', 'published-reports', 'period-ban'],
    edit_pdmr_pca_transaction: [
      'add-new-transaction',
      'upload-application',
      'pdmr-list',
      'period-ban',
      'sync-data',
      'published-reports',
      'period-ban',
    ],
    read_data_rooms: [
      'data-room-details',
      'data-room-folder',
      'control-panel-data-room',
      'market-data-room-details',
      'non-market-data-room-details',
      'data-rooms',
      'access-person',
    ],
    edit_data_rooms: [
      'data-room-details',
      'data-room-folder',
      'control-panel-data-room',
      'market-data-room-details',
      'non-market-data-room-details',
      'data-rooms',
      'access-person',
      'terms',
    ],
    read_users: ['users'],
    edit_users: ['users'],
  },
  pdmr: ['settings', 'add-new-transaction', 'upload-application', 'pdmr', 'my-logins', 'pdmr-fill-missing-data'],
  pca: ['pca', 'add-new-transaction', 'pdmr-fill-missing-data'],
  insider_list_user: ['control-panel-insider-list', 'specific-insider-details'],
  advisory_list_user: ['control-panel-advisory-list', 'advisory-insider-details'],
  /** Same access as advisory_list_user (API role name variant). */
  advisory_insider_list_user: ['control-panel-advisory-list', 'advisory-insider-details'],
  data_room_user: [
    'control-panel-data-room',
    'market-data-room-details',
    'non-market-data-room-details',
    'terms',
    'access-person',
    'data-rooms',
    'data-room-details',
    'data-room-folder',
  ],
};

export const roleDashboardPage = {
  admin: 'serviceprovider',
  client_contact: 'dashboard',
  delegated_user: 'dashboard',
  pdmr: 'pdmr',
  pca: 'pca',
  insider_list_user: 'control-panel-insider-list',
  advisory_list_user: 'control-panel-advisory-list',
  advisory_insider_list_user: 'control-panel-advisory-list',
  data_room_user: 'control-panel-data-room',
  guest: 'login',
};

/**
 * @param {string[]} roles
 * @param {string} pageName
 * */
export function hasRoleAccess(roles, pageName) {
  return ['all', ...roles].some((role) => {
    const pages = rolePagesAccess[role];
    return Array.isArray(pages) && pages.includes(pageName);
  });
}

/**
 * @param {string[]} permissions
 * @param {string} pageName
 * */
export function hasPermissionAccess(permissions, pageName, subscriptions = []) {
  const advisoryPages = ['advisory-companies', 'advisory-insider-lists', 'advisory-insider-details'];
  if (advisoryPages.includes(pageName) && subscriptions.includes('advisory_package')) {
    return true;
  }
  const delegatePermissions = Object.entries(rolePagesAccess.delegated_user);
  return (
    delegatePermissions
      .filter(([key]) => (key === 'all' ? true : permissions.includes(key)))
      .some(([, value]) => value.includes(pageName)) || hasRoleAccess(['auth'], pageName)
  );
}
